import { type Config, getConfig as getConfigNew } from '@atlassian/teams-common/context-config';

/**
 * @private
 * @deprecated use getConfig from `@atlassian/teams-common` instead
 */
export function getConfig(): Config {
	return getConfigNew();
}
